import { Select } from 'antd'

import { pick } from '@eastcoal/common/utils/object'

import { useRichEditorStore } from '@eastcoal/editor/Store/hooks/useStore'

import { LineHeightSelectProps } from './interface'

export const LineHeightSelect = (props: LineHeightSelectProps) => {
  const { lineHeightList, defaultLineHeight } = useRichEditorStore(state =>
    pick(state, ['lineHeightList', 'defaultLineHeight'])
  )

  return (
    <Select
      {...props}
      defaultValue={defaultLineHeight}
      options={lineHeightList}
    />
  )
}
